import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

type UserSettingsState = {
  theme: 'light' | 'dark';
  blockPrimaryModalCaseIds: string[];
  addBlockPrimaryModalCaseId: (id: string) => void;
  switchTheme: (theme: 'light' | 'dark') => void;
};

export const useUserSettingsStore = create<UserSettingsState>()(
  persist(
    (set) => ({
      theme: 'light',
      blockPrimaryModalCaseIds: [],
      addBlockPrimaryModalCaseId: (id: string) => {
        set((state) => ({ blockPrimaryModalCaseIds: [...state.blockPrimaryModalCaseIds, id] }));
      },
      switchTheme: (theme: 'light' | 'dark') => {
        set({ theme });
      },
    }),
    {
      name: 'user-settings',
      storage: createJSONStorage(() => localStorage),
      version: 1,
    },
  ),
);
